import React from 'react';

export default function TextBlockConfig({ data, onChange }) {
  const update = (field, value) => onChange({ ...data, [field]: value });

  return (
    <>
      <div className="adminblog-field">
        <label>Heading</label>
        <input type="text" value={data.heading || ''} onChange={(e) => update('heading', e.target.value)} placeholder="Section heading" />
      </div>
      <div className="adminblog-field">
        <label>Body</label>
        <textarea value={data.body || ''} onChange={(e) => update('body', e.target.value)} placeholder="Body text... Use double line breaks for paragraphs." rows={8} />
      </div>
      <div className="adminblog-field">
        <label>Columnas de texto</label>
        <select value={data.columns || 1} onChange={(e) => update('columns', parseInt(e.target.value))}>
          <option value={1}>1 columna</option>
          <option value={2}>2 columnas</option>
        </select>
      </div>
      <div className="adminblog-field">
        <label>Inline Pull Quote (optional)</label>
        <textarea value={data.pullQuote || ''} onChange={(e) => update('pullQuote', e.target.value || null)} placeholder="Optional quote within this text block" rows={2} />
      </div>
    </>
  );
}
